import { useQuery } from '@sequencehq/api'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { usePostHog } from 'posthog-js/react'

/**
 * Send an event to PostHog.
 */
export const useLogEvent = (): {
  logEvent: (args: {
    eventName: string
    metadata?: Record<string, unknown>
  }) => void
} => {
  const selfQuery = useQuery(dashboardv99990101Client.getSelf)
  const posthog = usePostHog()

  const currentAccountId = selfQuery.data?.sequenceAccounts[0]

  return {
    logEvent: args => {
      if (posthog.__loaded) {
        posthog.capture(args.eventName, {
          ...(args.metadata ?? {}),
          accountId: currentAccountId
        })
      }
    }
  }
}
